import { MemberProgram } from 'app-pages/pages/constants';
import axiosInstance from 'helpers/axiosInstance';

export const exclusionsPageCheckpoint = (memberId: string, answer: boolean, program: MemberProgram) => {
  const url = `/patients/patients/${memberId}/exclusions_page_checkpoint`;

  return axiosInstance.post(url, { answer, program });
};
